<template>
  <div ref="card" class="card" v-show="show" v-click-outside="closeCard" :style="adjustStyle">
    <div class="header">
      <div class="avatar">
        <img :src="content.avatar" alt="avatar">
      </div>
      <div class="user">
        <p class="name">{{content.name}}</p>
        <p>{{content.project_title}}</p>
      </div>
    </div>
    <div class="content">
      <div class="line">
        <img src="@assets/img/common/tel.svg" alt="tel">
        <p class="detail">{{content.tel}}</p>
      </div>
      <div class="line">
        <img src="@assets/img/common/mail.svg" alt="mail">
        <p class="detail">{{content.mail}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import vClickOutside from 'v-click-outside'

export default {
  name: 'card',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      show: true,
      defaultAvatar: require('@assets/img/common/defaultAvatar.png'),
      content: {
        avatar: require('@assets/img/common/defaultAvatar.png'),
        name: '',
        tel: '',
        mail: ''
      },
      adjustStyle: {}
    }
  },
  methods: {
    closeCard() {
      this.content = {
        avatar: this.defaultAvatar,
        name: '',
        tel: '',
        mail: ''
      }

      this.close()
    },
    open(id, e, type=0) {
      if (id == 0) return
      
      this.getUserCard(id, type)
      .then((r) => {
        this.show = true
        this.$nextTick(() => {
          this.adjustPosition(e)
        })
      })
    },
    adjustPosition(e) {
      // 根据视图调整窗口位置,使其能够出现在窗口内
      const cardElementRect = this.$refs.card.getBoundingClientRect()
      const elementBottom = cardElementRect.top + cardElementRect.height
      const elementRight = cardElementRect.left + cardElementRect.width
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      const gap = 20
      let mright = 0
      let mbottom = 0
      if (elementBottom >= windowHeight - 20) {
        mbottom = elementBottom - windowHeight + gap
      }

      if (elementRight >= windowWidth - 20) {
        mright = elementRight - windowWidth + gap
      }

      const adjustStyle = `
        top: ${e.clientY}px;left: ${e.clientX}px;
      `

      this.adjustStyle = adjustStyle
    },
    getUserCard(id, type) {
      // 获取用户卡片数据
      const info = {
        user_id: id,
        type: type
      }
      const obj = {
        data: info,
        hideLoading: true
      }

      return common.myFetch(apis.Usr_card, obj)
      .then((r) => {
        if (r) {
          const content = {
            avatar: r.avatar || this.defaultAvatar,
            name: r.truename || '无',
            tel: r.phone || '无',
            mail: r.email || '无',
            project_title: r.project_title || '无'
          }

          this.content = content
        }

        return r
      })
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .card {
    width: 246px;
    height: 196px;
    position: absolute;
    border-radius: 4px;
    overflow: hidden;
    background-color: rgba(5, 15, 15, .8);
    z-index: 999;
    .header {
      width: 100%;
      height: 94px;
      padding: 0 26px;
      // background-color: rgba(5, 15, 15, .8);
      display: flex;
      align-items: center;
      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        overflow: hidden;
        border: 2px solid #aaa;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .user {
        margin-left: 22px;
        font-size: 13px;
        color: @dateColor;
        .name {
          font-size: 18px;
          color: #fff;
        }
      }
    }
    .content {
      width: 100%;
      height: 102px;
      background-color: rgba(5, 15, 15, .75);
      padding: 0 26px;
      .line {
        height: 51px;
        width: 100%;
        display: flex;
        align-items: center;
        .detail {
          margin-left: 14px;
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }
</style>
